export default __webpack_public_path__ + "static/media/trophy.f14fbdc8.svg";